import { render } from "./Login.vue?vue&type=template&id=148898dc&scoped=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=148898dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-148898dc"

export default script